"use client";
import * as React from "react";
const SvgHelpFilled = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m.8 13.6H7.2V12h1.6zm1.66-6.2-.72.74a2.7 2.7 0 0 0-.94 2.26H7.2V10c0-.88.36-1.68.94-2.26l.99-1.01q.46-.45.47-1.13C9.6 4.72 8.88 4 8 4s-1.6.72-1.6 1.6H4.8a3.2 3.2 0 1 1 6.4 0c0 .7-.29 1.34-.74 1.8" }));
export {
  SvgHelpFilled as default
};
